import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@material-ui/core'
import Snowfall from 'react-snowfall'

import Social1 from 'assets/images/aboutus/1.png'
import Social2 from 'assets/images/aboutus/2.png'
import Social3 from 'assets/images/aboutus/3.png'
import Social4 from 'assets/images/aboutus/4.png'
import TogetherImg from 'assets/images/aboutus/together.png'
import MobileTogether from 'assets/images/aboutus/together_mobile.png'
import useWindowDimensions from 'hooks/useDimensions'
// import Snow1 from 'assets/images/aboutus/snow1.png'
// import Snow2 from 'assets/images/aboutus/snow2.png'
import Static1 from 'assets/images/aboutus/static1.png'
import Static2 from 'assets/images/aboutus/static2.png'
import Static3 from 'assets/images/character/static1.png'

const Aboutus: React.FC = () => {
    const screenWidth = useWindowDimensions().width
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        screenWidth > 420 ? setIsMobile(false) : setIsMobile(true)
    }, [screenWidth])
    return (
        <>
            <StyledContainer>
                <OlafText>Lets do it together!</OlafText>
                <Text>
                    Don't miss this exclusive pre-sale.<br />
                    Subscribe to us to always be aware of the news
                </Text>
                <SocialGroup>
                    <img onClick={() => window.open('https://twitter.com/frozenexchange', '_blank')} src={Social1} alt='' />
                    <img onClick={() => window.open('https://t.me/frozenexchange', '_blank')} src={Social2} alt='' />
                    <img onClick={() => window.open('https://www.reddit.com/user/frozenexchange', '_blank')} src={Social3} alt='' />
                    <img onClick={() => window.open('https://medium.com/@frozenexchange', '_blank')} src={Social4} alt='' />
                </SocialGroup>
                <Box>
                    support@frozen.exchange
                </Box>
                {/* {isMobile && <img src={Snow1} alt='' />} */}
                {/* <img src={Snow2} alt='' /> */}
                <img src={Static3} alt='' />
            </StyledContainer>
            <Together position='relative' overflow='hidden'>
                {isMobile ?
                    <img src={MobileTogether} width='100%' alt='' />
                    :
                    <img src={TogetherImg} width='100%' alt='' />
                }
                <SnowBox>
                    <Snowfall snowflakeCount={30}/>
                </SnowBox>
                <img src={Static1} alt='' />
                <img src={Static2} alt='' />
            </Together>
            <CopyrightBox>
                (C) Frozen Exchange 2021
            </CopyrightBox>
        </>
    )
}

const Together=styled(Box)`
    position: relative;
    >img:nth-of-type(2) {
        position: absolute;
        width: calc(100% - 116.15px);
        left: 84px;
        top: -24%;
        @media (max-width: 767px) {
            display: none;
        }
    }
    >img:nth-of-type(3) {
        position: absolute;
        width: calc(100% - 131.15px);
        left: 59px;
        top: -5%;
        @media (max-width: 767px) {
            display: none;
        }
    }
`

const SnowBox = styled(Box)`
    canvas {
    }
`

const CopyrightBox = styled(Box)`
    margin-top: 24px;
    margin-bottom: 22px;
    font-size: 18px;
    @media (max-width: 1100px) {
        font-size: 12px;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    line-height: 32px;
    text-align: center;
    color: #020202;
`

const SocialGroup = styled(Box)`
    margin-top: 49px;
    display: flex;
    justify-content: center;
    >img {
        cursor: pointer;
        pointer-events: initial !important;
    }
    >img+img {
        margin-left: 19px;
        @media (max-width:767px) {
            margin-left: 9px;
        }
    }
`

const Text = styled(Box)`
    position: relative;
    z-index: 1;
    margin-top: 42px;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    @media (max-width:767px) {
        margin-top: 19px;
        font-size: 18px;
        line-height: 24px;
        padding-left: 42px;
        padding-right: 41px;
    }
    @media (max-width:360px) {
        padding-left: 29px;
        padding-right: 24px;
    }
    text-align: center;
    color: #020202;
`

const OlafText = styled(Box)`
    position: relative;
    z-index: 1;
    @media (max-width:767px) {
        font-size: 36px;
        line-height: 42px;
        padding-left: 26px;
        padding-right: 28px;
    }
    font-weight: bold;
    font-size: 50px;
    line-height: 109%;
    color: #3F78BD;
    text-align: center;
    span {
        font-weight: bold;
        font-size: 50px;
        line-height: 109%;
        color: #f6669e;
    }
`

const StyledContainer = styled(Box)`
    position: relative;
    z-index: 3;
    background-image: linear-gradient(90deg, #bfd9ee 0%, #cee2f2 50%, #bfd9ee 100%);
    padding-top: 70px;
    padding-bottom: 64px;
    @media (max-width:767px) {
        padding-top: 74px;
        padding-bottom: 58px;
    }
    >div:last-of-type {
        font-weight: 500;
        font-size: 28px;
        line-height: 42px;
        text-align: center;
        color: #3F78BD;
        margin-top: 27px;
        @media (max-width:767px) {
            margin-top: 31px;
            font-size: 20px;
            line-height: 30px;
        }
    }
    >img {
        position: absolute;
    }
    >img:first-of-type {
        left: 38px;
        top: -24%;
        @media (max-width:767px) {
            left: 20px;
            top: 10%;
        }
    }
`

export default Aboutus